import {defineStore} from 'pinia'
import axios from '@/api/axios'

export const usePinterestBusinessManagerStore = defineStore({
  id: 'pinterestBusinessManagerStore',
  state: () => ({
    pinterestBusinessManagers: [],
    pinterestBusinessManagersLoading: false,
    error: null,
  }),
  actions: {
    async getPinterestBusinessManagers(filters = {}, withRelation = undefined) {
      this.error = null
      this.pinterestBusinessManagersLoading = true

      try {
        const {data} = await axios.get('pinterest/business-managers', {
          params: {...filters, with: withRelation},
        })

        this.pinterestBusinessManagers = data

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.pinterestBusinessManagersLoading = false
      }
    },
  },
})